/* eslint-disable */

import ActiveService from  '@/service.active';

export class UploadService extends ActiveService {
	/**
	 *
	 * @param $injector
	 * @param $companies
	 * @param $filter
	 */
	constructor($injector, $filter) {
		"ngInject";
		super($injector);
		//this.$company = $companies.get();
		this.$filter = $filter;
	}

	upload(uri, file) {
		this.deferred = this.$q.defer();
		this.initUpload(uri, file);
		return this.deferred.promise;

		// let deferred = this.$q.defer();
		// let config;
		// if (query) {
		// 	config = {
		// 		paramSerializer: "$httpParamSerializerJQLike",
		// 		params: query,
		// 		cache: false
		// 	};
		// }
		// this.$http
		// 	.get(url, config)
		// 	.then(response => {
		// 		deferred.resolve(response.data);
		// 	})
		// 	.catch(errors => deferred.reject(errors));
		// return deferred.promise;
	}

	/**
	 *
	 * @param file
	 */
	initUpload(uri, file, docType='ADR') {
		const data = {
			name: file.name,
		};
		return this.$http.post(uri, data)
			.then(response => {
				const data = response.data;
				if (data) {
					console.log("Wgrywanie pliku rozpoczęte. Poinformujemy Cię o zakończeniu procesu.");
					return this.uploadFile(file, data.upload_method, data.uris.Upload, data.uris.UploadedFiles);
				} else {
					console.log("Wystąpił problem podczas wgrywania pliku. Spróbuj ponownie.");
				}
			})
			.catch(errors => {
				this.deferred.reject(errors);
				console.log(errors);
			});
	}

	/**
	 *
	 * @param file
	 * @param method
	 * @param uploadUri
	 * @param finishUri
	 */
	uploadFile(file, method, uploadUri, finishUri) {
		return this.$http({
			url: uploadUri,
			method: method,
			data: file,
			headers: {
				"Content-Type": file.type,
				"Content-Range": `bytes 0-${file.size - 1}/${file.size}`,
				"X-Upload-Content-Length": file.size,
				"X-Upload-Content-Type": file.type
			}
		})
			.then(response => {
				const data = response;
				if (!data.error) {
					data.contentType = data.contentType || file.type;
					return this.finishUpload(finishUri, data.data, response.status);
				} else {
					// Handle errors here
					console.log("ERRORS: " + data.error);
					console.log("Wystąpił problem podczas wgrywania pliku. Spróbuj ponownie.");
				}
			})
			.catch(errors => {
				this.deferred.reject(errors);
				console.log(errors);
			});
	}

	/**
	 *
	 * @param finishUri
	 * @param data
	 * @param statusCode
	 */
	finishUpload(finishUri, data, statusCode) {
		const _data = {
			"response_content": data,
			"status_code": statusCode,
			"doc_type": "ADR",
		};
		return this.$http
			.post(finishUri, _data)
			.then((response) => this.deferred.resolve(response.data))
			.then(() => this.notify.set(this.$filter("translate")("UPLOAD_SUCCESS"), "success"))
			.catch((errors) => {
				this.deferred.reject(errors);
				this.notify.set(this.$filter("translate")("UPLOAD_ERROR"), "error")
			});
	}

}



/** WEBPACK FOOTER **
 ** ./frontend/components/utility/upload/upload.service.js
 **/